<template>
  <div class="hello" style="background-color: #f6f6f6">
    <div class="header">
      <div @click="backJump" style="color: #fff; padding-top: 10px; margin-left: 10px">
        <span style="line-height: 30px"
          ><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>返回</span
        >
      </div>
      <div class="clear"></div>
      <img
        src="../assets/topback.png"
        style="width: 50%; height: 75%; float: right; margin-top: -10px"
        alt=""
      />
      <div>
        <h3><span>电</span>费后付费账单</h3>
      </div>
    </div>

    <div class="center" style="position: relative">
      <div class="content">
        <div class="content_top">
          <div class="bt">
            <img src="../assets/dian.png" />
            <span>电费</span>
          </div>
          <div id="topone">
            <span style="font-size: 15px; color: #8e8e8e">识别编码信息</span
            ><span style="font-size: 15px; float: right">{{
              allBody.houseHoldNumber
            }}</span>
          </div>
          <div id="topone">
            <span style="font-size: 15px; color: #8e8e8e">住址信息</span
            ><span style="font-size: 15px; float: right">{{ allBody.address }}</span>
          </div>
          <div style="margin-top: 50px; margin-bottom: 20px">
            <button
              @click="hhh"
              style="
                width: 80px;
                height: 30px;
                border: 1px solid #2d86f6;
                border-radius: 5px;
                text-align: center;
                float: left;
                background-color: #fff;
                color: #2d86f6;
              "
            >
              {{ year }}
            </button>
            <button
              @click="qisclick"
              style="
                width: 50px;
                height: 30px;
                border: 1px solid #2d86f6;
                border-radius: 5px;
                text-align: center;
                background-color: #fff;
                margin-left: 20px;
                color: #2d86f6;
              "
            >
              {{ content.billIssue }}
            </button>
            <div class="clear" style="clear: both"></div>
            <van-popup v-model="show" position="bottom" style="width: 100%; height: 30%">
              <van-picker
                title="请选择年"
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
              />
            </van-popup>
            <van-popup
              v-model="showprides"
              position="bottom"
              style="width: 100%; height: 30%"
            >
              <van-picker
                title="请选择期数"
                show-toolbar
                :columns="periods"
                @confirm="periodsonConfirm"
              />
            </van-popup>
          </div>
          <div style="border-bottom: 1px solid #dee1e5">
            <span style="font-size: 20px; color: #0f72dd; float: left">
              {{ content.paymentAll }}
            </span>
            <div class="clear"></div>
            <div class="kuan">
              <span style="float: left; margin-top: 8px; font-size: 10px"
                >合计金额（元)</span
              >
            </div>
            <div style="margin-bottom: 10px">
              <span style="font-size: 12px" v-if="content.billPeriodStart != ''">
                用水周期：{{ content.billPeriodStart }} - {{ content.billPeriodEnd }}
              </span>
              <span style="font-size: 12px" v-else> 用水周期： </span>
            </div>
          </div>
          <div class="allz">
            <p style="font-size: 20px; color: #0f72dd">{{ content.usedTotal }}</p>
            <p style="font-size: 12px">合计电量（Kw·h）</p>
            <p style="font-size: 12px; margin-top: 5px" v-if="content.uptime != ''">
              数据更新时间：{{ content.uptime }}
            </p>
            <p style="font-size: 12px; margin-top: 5px" v-else-if="content.uptime == ''">
              数据更新时间：
            </p>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="content_bottom">
          <div style="text-align: left; font-size: 20px; margin-top: 20px">
            <p style="color: #0f72dd">电量使用情况</p>
            <table
              border="0"
              cellspacing="10"
              cellpadding=""
              style="
                width: 100%;
                margin-top: 30px;
                font-size: 15px;
                border-bottom: 1px solid #8e8e8e;
              "
            >
              <thead>
                <tr>
                  <th></th>
                  <th align="center" valign="middle">单价</th>
                  <th align="center" valign="middle">计费数量</th>
                  <th align="center" valign="middle">金额</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td align="center" valign="middle">有功（尖）</td>
                  <td align="center" valign="middle">{{ content.eleTopPrice }}</td>
                  <td align="center" valign="middle">{{ content.eleTopAmount }}</td>
                  <td align="center" valign="middle">{{ content.eleTopAmountMoney }}</td>
                </tr>
                <tr>
                  <td align="center" valign="middle">有功（峰）</td>
                  <td align="center" valign="middle">{{ content.elePeakPrice }}</td>
                  <td align="center" valign="middle">{{ content.elePeakAmount }}</td>
                  <td align="center" valign="middle">{{ content.elePeakAmountMoney }}</td>
                </tr>
                <tr>
                  <td align="center" valign="middle">有功（平）</td>
                  <td align="center" valign="middle">{{ content.eleNormalPrice }}</td>
                  <td align="center" valign="middle">{{ content.eleNormalAmount }}</td>
                  <td align="center" valign="middle">
                    {{ content.eleNormalAmountMoney }}
                  </td>
                </tr>
                <tr>
                  <td align="center" valign="middle">有功（谷）</td>
                  <td align="center" valign="middle">{{ content.eleValleyPrice }}</td>
                  <td align="center" valign="middle">{{ content.eleValleyAmount }}</td>
                  <td align="center" valign="middle">
                    {{ content.eleValleyAmountMoney }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              border="0"
              cellspacing="10"
              cellpadding=""
              style="width: 100%; font-size: 15px; border-bottom: 1px solid #8e8e8e"
            >
              <thead>
                <tr>
                  <th></th>
                  <th align="center" valign="middle">上次/本次</th>
                  <th align="center" valign="middle">抄见电量</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td align="center" valign="middle">有功（尖）</td>
                  <td align="center" valign="middle">
                    {{ content.eleTopNumberLast }}/{{ content.eleTopNumberThis }}
                  </td>
                  <td align="center" valign="middle">{{ content.eleTopAmount }}</td>
                </tr>
                <tr>
                  <td align="center" valign="middle">有功（峰）</td>
                  <td align="center" valign="middle">
                    {{ content.elePeakNumberLast }}/{{ content.elePeakNumberThis }}
                  </td>
                  <td align="center" valign="middle">{{ content.elePeakAmount }}</td>
                </tr>
                <tr>
                  <td align="center" valign="middle">有功（平）</td>
                  <td align="center" valign="middle">
                    {{ content.eleNormalNumberLast }}/{{ content.eleNormalNumberThis }}
                  </td>
                  <td align="center" valign="middle">{{ content.eleNormalAmount }}</td>
                </tr>
                <tr>
                  <td align="center" valign="middle">有功（谷）</td>
                  <td align="center" valign="middle">
                    {{ content.eleValleyNumberLast }}/{{ content.eleValleyNumberThis }}
                  </td>
                  <td align="center" valign="middle">{{ content.eleValleyAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p style="font-size: 15px; margin-top: 20px; margin-bottom: 20px">
            <span>手续费</span><span style="float: right">{{ content.taxPrice }}</span>
          </p>

          <van-button
            type="primary"
            block
            v-if="status == 1"
            @click="goJump"
            style="
              background-color: #2d86f6;
              font-size: 17px;
              letter-spacing: 1px;
              border-radius: 10px;
              height: 50px;
            "
            >立即缴费</van-button
          >
          <van-button
            disabled
            v-else-if="status == 0"
            type="primary"
            style="
              background-color: #c8c9cc;
              font-size: 17px;
              letter-spacing: 1px;
              border-radius: 10px;
              height: 50px;
              width: 100%;
            "
            >已完成缴费</van-button
          >
        </div>
      </div>
    </div>
    <!-- <div class="foot" style="height: 200px;box-sizing: border-box;padding: 30px">
      <p style="color:#0f72dd;font-weight: bold;">账户</p>
      <p style="border-bottom: 1px solid #eeeeee;margin-top: 10px"></p>
      <div style="margin-top: 35px;display: flex;justify-content: center;align-items: center;flex-direction: column">
        <div style="font-size: 22px;font-weight: bold">账户余额</div>
        <div style="font-size: 20px;color: #00afff;margin-top: 10px">
          <span>￥</span><span>{{ this.balanceAddData }} </span><span> 元</span></div>
      </div>

    </div> -->

    <div class="foot">
      <div class="bot">
        <p style="color: #0f72dd">缴费服务</p>
        <div style="border-bottom: 1px solid #8e8e8e; height: 70px; margin-top: 35px">
          <img src="../assets/money.png" style="width: 50px; float: left" alt="" />
          <div style="margin-left: 60px">
            <span>缴费记录</span>
            <button
              @click="element"
              style="
                border: none;
                width: 80px;
                border-radius: 50px;
                background-color: #0f72dd;
                color: #fff;
                height: 30px;
                line-height: 30px;
                float: right;
                margin-top: 10px;
              "
            >
              进入
            </button>
            <p>可查询每笔缴费记录</p>
          </div>
        </div>
        <div>
          <img src="../assets/jil.png" style="width: 50px; float: left" alt="" />
          <div style="margin-left: 60px">
            <span>用量记录</span>
            <button
              @click="balance"
              style="
                border: none;
                width: 80px;
                border-radius: 50px;
                background-color: #0f72dd;
                color: #fff;
                height: 30px;
                line-height: 30px;
                float: right;
                margin-top: 10px;
              "
            >
              进入
            </button>
            <p>日报、周报、月报</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { billList, periods, postpaid, billData, getBalance } from "../common/api/elall";
import jump from "../common/jump";

export default {
  data() {
    return {
      id: "",
      payer: "",
      text: "",
      qis: "",
      allelectric: "",
      houseHoldNumber: "",
      address: "",
      showprides: false,
      wuy: "",
      charge: "",
      status: true,
      periods: [],
      year: "2022",
      show: false,
      value1: 0,
      start: "",
      end: "",
      devId: "",
      showPicker: false,
      projectId: "",
      projectName: "",
      columns: [],
      uptime: "",
      mchNumber: "",
      payType: 1,
      all: [],
      houseHold: "",
      content: [],
      allBody: [],
      balanceAddData: "",
    };
  },
  mounted() {
    this.houseHold = this.$route.query.houseHoldNumber;
    console.log("elall.vue接收index.vue 传递过来的query路由参数", this.$route.query);
    this.allBody = {
      houseHoldNumber: this.$route.query.houseHoldNumber,
      phone: this.$route.query.phone,
      tenantId: this.$route.query.tenantId,
      mchName: this.$route.query.mchName,
      mchNumber: this.$route.query.mchNumber,
      address: this.$route.query.address,
      payType: this.$route.query.payType,
      devId: this.$route.query.devId,
      devType: this.$route.query.devType,
      productId: this.$route.query.productId,
      id: this.$route.query.id,
      actId: this.$route.query.actId,
    };
    this.getContent();
    this.balanceData();
    var date = new Date();
    for (let i = 0; i <= 5; i++) {
      let year = date.getFullYear() - i;
      this.columns.push(year);
    }
  },
  methods: {
    balanceData() {
      getBalance({ actId: this.allBody.actId }).then((response) => {
        const [{ balance, houseHoldNumber }] = response.data;
        this.balanceAddData =
          houseHoldNumber === this.allBody.houseHoldNumber ? balance : "暂无数据";
      });
    },
    qisclick() {
      this.showprides = !this.showprides;
    },
    getContent() {
      postpaid({ houseHoldNumber: this.houseHold })
        .then((response) => {
          // console.log("content", response.data)
          if (200 !== response.code) {
            this.$toast.fail(response.msg);
            console.log("content", response.data);
            return;
          }
          if (0 == response.data.items.length) {
            this.$toast.fail("生成账单的才可以缴费");
            return;
          }
          for (let i = 0; i < response.data.items.length; i++) {
            this.periods.push(response.data.items[i].billIssue);
          }
          let i = response.data.items.length - 1;
          if (response.data.items[i].status == 0) {
            this.status = true;
          } else {
            this.status = false;
          }
          console.log("介个", response.data);
          this.content = response.data.items[0];
          console.log("this", this.content);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    element() {
      console.log("houseHold", this.allBody.houseHoldNumber);
      this.$router.push({
        path: "/element",
        query: { houseHold: this.allBody.houseHoldNumber },
      });
    },
    balance() {
      this.$router.push({
        path: "/balance",
        query: {
          houseHold: this.allBody.houseHoldNumber,
          address: this.allBody.address,
          text: "",
          balance: "",
        },
      });
    },
    goJump() {
      this.price = this.math;
      var data = JSON.stringify({
        price: this.content.paymentAll,
        devId: this.content.devId,
        houseHoldNumber: this.content.houseHoldNumber,
        payType: this.payType,
        phone: this.allBody.phone,
        devAddress: this.allBody.address,
        useType: 3,
        mchName: this.allBody.mchName,
        mchNumber: this.allBody.devType,
        type: 0,
        billId: this.allBody.id,
        tenantId: this.allBody.tenantId,
        productId: this.allBody.productId,
        payment: this.allBody.payType,
      });
      console.log(data);
      billList(data)
        .then((reson) => {
          if (500 == reson.code) {
            this.$toast.fail(reson.msg);
            return;
          }
          this.jsap(reson.data.orderNo, this.allBody.devType);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    jsap(orderNo, devType) {
      console.log(orderNo);
      this.typ = window.__wxjs_environment;
      var isWxMini = window.__wxjs_environment === "miniprogram"; // 判断场景是否小程序
      const url =
        "/pages/logs/logs?orderNo=" +
        orderNo +
        "&token=" +
        this.$cookies.get("token") +
        "&devType=" +
        devType;
      console.log(url);
      if (isWxMini) {
        this.typ = "11跳转";
        wx.miniProgram.navigateTo({
          url: url,
        });
      } else {
        this.$toast("请在微信端重新操作");
      }
    },
    backJump() {
      this.$destroy();
      jump.$emit("back");
      this.$router.go(-1);
    },
    hhh() {
      this.show = !this.show;
    },

    //期数
    periodsonConfirm(value) {
      periods({
        houseHoldNumber: this.allBody.houseHoldNumber,
        billYear: this.year,
        billIssue: value,
      }).then((response) => {
        console.log("期数", response.data);
        if (response.data.items[0].status == 0) {
          this.status = true;
        } else {
          this.status = false;
        }
        this.content = [];
        this.content = response.data.items[0];
      });
      this.qisclick();
    },
    onConfirm(value, index) {
      this.year = `${value}`;
      console.log(this.year);

      postpaid({ houseHoldNumber: this.allBody.houseHoldNumber, billYear: value }).then(
        (response) => {
          console.log(response.data);
          this.content = [];
          if (response.data.items.length == 0) {
          } else {
            let all = response.data.items.length;
            for (let i = 0; i < all; i++) {
              this.periods.push(response.data.items[i].billIssue);
            }
            if (response.data.items[0].status == 0) {
              this.status = true;
            } else {
              this.status = false;
            }
            this.content = response.data.items[0];
          }
        }
      );

      this.hhh();
    },
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "." + MM + "." + d;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.header {
  width: 100%;
  height: 192px;
  background-color: #295ad0;
}

.header h3 {
  letter-spacing: 2px;
  color: rgb(255, 255, 255);
  line-height: 120px;
  position: relative;
  margin-left: 20px;
}

.header h3 span {
  border-bottom: 3px solid #fff;
}

.content {
  width: 90%;
  margin: 0 auto;
  background-color: #fff;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin-top: -15px;
  padding-top: 5px;
}

.content_top {
  width: 80%;
  margin: 0 auto;
  height: 480px;
}

.bt {
  margin-top: 20px;
}

.bt img {
  width: 38px;
  height: 38px;
  float: left;
}

.bt span {
  line-height: 42px;
  margin-left: 10px;
  font-size: 20px;
}

#topone {
  margin-top: 20px;
}

select {
  float: left;
}

select option {
  font-size: 15px;
}

ul li {
  width: 20%;
  height: 50px;
  background-color: #51b1d9;
  float: left;
  list-style: none;
}

.kuan {
  height: 48px;
  margin-top: 2px;
}

.sum {
  width: 63%;
  font-size: 10px;
  float: right;
  margin-top: 8px;
  margin-right: 5px;
}

.allz {
  margin-top: 20px;
}

.allz p {
  margin-top: 20px;
}

.clear {
  clear: both;
}

.bottom {
  width: 90%;
  margin: 0 auto;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin-top: 20px;
  background-color: #fff;
  padding-top: 15px;
  padding-bottom: 20px;
}

.content_bottom {
  width: 80%;
  margin: 0 auto;
  padding-bottom: 10px;
}

.foot {
  width: 90%;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  height: 260px;
  margin: 0 auto;
  margin-top: 30px;
  background-color: #fff;
}

.bot {
  width: 80%;
  margin: 0 auto;
  padding-top: 30px;
}

.bot div {
  margin-top: 20px;
}

.bot div p {
  font-size: 14px;
  color: #8e8e8e;
  margin-top: 5px;
}
</style>
